import { SpotWage } from '../../shared/spot-wage';
import { Division } from '../division';

export class DivisionSpotWage extends SpotWage {
  divisionID: string;
  division: Division;

  constructor(jsonData?: Partial<DivisionSpotWage>) {
    super(jsonData);
    if (jsonData) {
      if (jsonData.division) {
        this.division = new Division(jsonData.division);
      }
    }
  }
}
